// Libraries
import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import {
   makeStyles,
   Grid,
   Typography,
   Divider,
   Popover
} from '@material-ui/core'
import DescriptionIcon from '@material-ui/icons/DescriptionOutlined'
import PolicyIcon from '@material-ui/icons/Policy'
import SecurityIcon from '@material-ui/icons/Security'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import LibraryBooksOutlinedIcon from '@material-ui/icons/LibraryBooksOutlined'
import LanguageIcon from '@material-ui/icons/Language'

// Subcomponents
import RegulationsSummary from './regulationsSummary'
import AddNewRegulation from './addNewRegulation'

function HelpPopover({ anchorEl, setAnchorEl }) {
   const open = Boolean(anchorEl)
   const id = open ? 'simple-popover' : undefined

   function handleClose() {
      setAnchorEl(null)
   }

   return (
      <Popover
         id={id}
         open={open}
         anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
         transformOrigin={{ vertical: 'top', horizontal: 'right' }}
         anchorEl={anchorEl}
         onClose={handleClose}
      >
         <HelpContainer handleClose={handleClose} />
      </Popover>
   )
}
export default HelpPopover

// --------------------------------------

const helpContainerStyles = makeStyles(theme => ({
   popoverContent: {
      width: 'auto',
      display: 'flex',
      flexDirection: 'column',
      borderTop: '4px solid #3264DC',
      padding: theme.spacing(0.5, 2, 2)
   }
}))

function HelpContainer({ handleClose }) {
   const classes = helpContainerStyles()
   const [currentView, setCurrentView] = useState('helpView')

   return (
      <Grid className={classes.popoverContent}>
         {currentView === 'helpView' && (
            <HelpView
               setCurrentView={setCurrentView}
               handleClose={handleClose}
            />
         )}
         {currentView === 'legalMattersView' && (
            <LegalMattersView setCurrentView={setCurrentView} />
         )}
         {currentView === 'regulationsSummaryView' && (
            <RegulationsSummary
               setCurrentView={setCurrentView}
               handleClose={handleClose}
            />
         )}
         {currentView === 'addNewRegulationView' && (
            <AddNewRegulation
               setParentView={setCurrentView}
               handleClose={handleClose}
            />
         )}
      </Grid>
   )
}

// -------------------------------------

const helpViewStyles = makeStyles(theme => ({
   title: {
      margin: theme.spacing(1, 0),
      fontWeight: 'bold'
   },
   item: {
      display: 'flex',
      cursor: 'pointer',
      marginTop: theme.spacing(2)
   },
   icon: {
      marginRight: theme.spacing(2)
   }
}))

function Help({ setCurrentView, handleClose }) {
   const classes = helpViewStyles()

   function goToLegalMatters() {
      setCurrentView('legalMattersView')
   }

   function goToRegulationsSummary() {
      setCurrentView('regulationsSummaryView')
   }

   function goToMutualWorld() {
      handleClose()
      window.open('/dashboard/mutual-world', '_blank')
   }

   return (
      <Grid>
         <Typography className={classes.title}>Ayuda</Typography>
         <Divider />
         <div className={classes.item} onClick={goToLegalMatters}>
            <DescriptionIcon className={classes.icon} />
            <Typography>Asuntos Legales</Typography>
         </div>
         <div className={classes.item} onClick={goToRegulationsSummary}>
            <LibraryBooksOutlinedIcon className={classes.icon} />
            <Typography>Circulares y Normativas</Typography>
         </div>
         {/* <div className={classes.item} onClick={goToMutualWorld}>
            <LanguageIcon className={classes.icon} />
            <Typography>Mundo Mutual</Typography>
         </div> */}
      </Grid>
   )
}

const HelpView = withRouter(Help)

// ----------------------------------

const legalMattersStyles = makeStyles(theme => ({
   titleContainer: {
      display: 'flex',
      margin: theme.spacing(1, 0)
   },
   title: {
      fontSize: 16,
      fontWeight: 'bold',
      margin: 'auto'
   },
   backButton: {
      cursor: 'pointer'
   },
   item: {
      display: 'flex',
      cursor: 'pointer',
      marginTop: theme.spacing(2)
   },
   icon: {
      marginRight: theme.spacing(2)
   },
   link: {
      color: '#43496A',
      textDecoration: 'none'
   }
}))

function LegalMatters({ setCurrentView, history }) {
   const classes = legalMattersStyles()

   function goToHelpView() {
      setCurrentView('helpView')
   }

   function goToSitePolicies() {
      history.push('/site-policies')
   }

   return (
      <Grid>
         <div className={classes.titleContainer}>
            <ArrowBackIcon
               className={classes.backButton}
               onClick={goToHelpView}
            />
            <Typography className={classes.title}>Asuntos Legales</Typography>
         </div>
         <Divider />
         <div className={classes.item} onClick={goToSitePolicies}>
            <PolicyIcon className={classes.icon} />
            <Typography>Políticas del sitio</Typography>
         </div>
         <div className={classes.item}>
            <SecurityIcon className={classes.icon} />
            <a
               className={classes.link}
               href="https://www.mutualser.com/images/documentos/Quienes_Somos/POL-TIC-03%20POLITICAS%20DE%20SEGURIDAD%20DE%20LA%20INFORMACION.pdf"
               target="_blank"
               rel="noreferrer"
            >
               <Typography>Políticas de privacidad</Typography>
            </a>
         </div>
      </Grid>
   )
}

const LegalMattersView = withRouter(LegalMatters)
